import { TitleButtonDivider } from '@/common/buttons/TitleButtonDivider';
import { EntityPerspective } from '@/common/entityFramework/entityPerspective/EntityPerspective';
import { MassOverwriteButton } from '@/common/entityFramework/entityPerspective/overwrite/MassOverwriteButton';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback, useRef } from 'react';
import { TheraSelect } from '../../../theraSelect/TheraSelect';

export const AbvRbtPipeOverUnderPerspective = ({ overUnderScenId }) => {

  const entityPerspectiveRef = useRef();
  const theraSelectRef = useRef();

  const entity = 'RBT_PIPE_OVER_UNDER';

  const views = [
    {
      name: 'Full Breakout',
      dims: ['OVER_UNDER_SCEN', 'CHANNEL', 'PROD'],
      kpis: ['QTRLY_LBE_AMT', 'MONTHLY_LBE_AMT', 'PIPE_BAL', 'LBE_PIPE_ADJ', 'NON_LBE_PL_ADJ', 'TOTAL_PL_ADJ', 'BS_ADJ', 'TOTAL_LBE_ADJ', 'PROPOSED_BAL', 'MIDPOINT', 'MOS', 'LBE_MOS', 'VALUE_OF_ONE_TICK', 'OVER_UNDER_AMT'],
      disabledDims: ['OVER_UNDER_SCEN'],
      numFrozenDims: 1,
    }
  ];

  const getContextMenuItems = (params) => {
    let contextMenus = entityPerspectiveRef.current.getContextMenuItems(params);

    let proposedAdjSubMenu = [
      {
        name: 'Balance Pipeline Reclass',
        action: () => entityPerspectiveRef.current.navigateToPerspectiveAdj(
          params,
          'BS_ADJ',
          'B/S Pipeline Reclass'
        ),
        icon: fas.faSlidersH
      },
      {
        name: 'P/L Pipeline Adjustments',
        action: () => entityPerspectiveRef.current.navigateToPerspectiveAdj(
          params,
          'NON_LBE_PL_ADJ',
          'Non LBE P/L Pipeline Adjustments'
        ),
        icon: fas.faSlidersH
      }
    ];
    contextMenus.push(
      {
        name: 'Adjustments',
        subMenu: proposedAdjSubMenu,
        icon: fas.faSlidersH
      }
    );

    return contextMenus;
  }

  const defaultDimFilters = { OVER_UNDER_SCEN: [overUnderScenId] };

  const handleViewReset = useCallback(() => {
    theraSelectRef.current.reset();
  }, []);

  const events = {
    onDimFilterChange: ({ dimCode }) => {
      if (dimCode === 'PROD') {
        theraSelectRef.current.reset();
      }
    }
  };

  const augButtons = (buttons) => {
    buttons.unshift(
      <TheraSelect entityPerspectiveRef={entityPerspectiveRef} ref={theraSelectRef} />,
      <MassOverwriteButton
        toolTip={'Adjust Rebate Pipeline Over/(Under)'}
        kpiCodes={['NON_LBE_PL_ADJ', 'BS_ADJ']}
        entity={entity}
        defaultDimValues={{ OVER_UNDER_SCEN: overUnderScenId }}
      />,
      <TitleButtonDivider key="filterButtonDivider" />,
    );
  }

  return (
    <EntityPerspective
      ref={entityPerspectiveRef}
      entity={entity}
      defaultDimFilters={defaultDimFilters}
      onViewReset={handleViewReset}
      augButtons={augButtons}
      events={events}
      views={views}
      gridOptions={{
        getContextMenuItems
      }}
    />
  )
}